export const state = () => ({
	all_experiences: [],
	experience: null,
	experience_company: null,
	experience_job: null,
	current_step: 1,
	job_industries: [],
});

export const mutations = {
	setAllExperiences(state: any, payload: any) {
		state.all_experiences = payload;
	},
	setExperience(state: any, payload: any) {
		state.experience = payload;
	},
	setCurrentStep(state: any, payload: any) {
		state.current_step = payload;
	},
	setExperienceCompany(state: any, payload: any) {
		state.experience_company = payload;
	},
	setExperienceJob(state: any, payload: any) {
		state.experience_job = payload;
	},
	setJobIndustries(state: any, payload: any) {
		state.job_industries = payload;
	},
};

export const getters = {
	getAllExperiences: (state: any) => state.all_experiences,
	getExperience: (state: any) => state.experience,
	getCurrentStep: (state: any) => state.current_step,
	getExperienceCompany: (state: any) => state.experience_company,
	getExperienceJob: (state: any) => state.experience_job,
	getJobIndustries: (state: any) => state.job_industries,
};

export const actions = {
	async getAllExperiences(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/work-experiences')
				.then((res) => {
					state.commit('setAllExperiences', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async getExperience(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/work-experiences/' + payload)
				.then((res) => {
					state.dispatch('updateExperience', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createExperience(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/work-experiences', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateAddress(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(
					'/api/profile/work-experiences/' +
						payload.uuid +
						'/address',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createExperienceIndustry(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					`/api/profile/work-experiences/${payload.uuid}/industries`,
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteExperienceIndustry(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete(
					`/api/profile/work-experiences/industries/${payload.uuid}`,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateExperienceInterests(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					`/api/profile/work-experiences/industries/${payload.uuid}/fields-of-interest`,
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editExperience(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put(
					'/api/profile/work-experiences/' + payload.uuid,
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteExperience(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/work-experiences/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createExperienceReference(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/work-experiences/' +
						payload.uuid +
						'/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/work-experiences/' +
						payload.uuid +
						'/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAllExperiences(state: any, payload: any) {
		state.commit('setAllExperiences', payload);
	},

	updateExperience(state: any, payload: any) {
		let companyInfo = {
			company_name: payload.company_name,
			industry_uuid: payload.industries[0]?.industry_uuid || null,
			address: payload.address,
			contact_number: payload.contact_number,
			website_url: payload.website_url,
			facebook_url: payload.facebook_url,
			linkedin_url: payload.linkedin_url,
			instagram_url: payload.instagram_url,
		};

		let jobInfo = {
			job_title: payload.job_title,
			is_current: payload.is_current,
			start_date: payload.start_date,
			end_date: payload.end_date,
			description: payload.description,
			comment: payload.comment,
			fields_of_interest:
				payload.industries[0]?.fields_of_interest || null,
		};

		let industries = payload.industries;

		state.commit('setExperience', payload);
		state.commit('setExperienceCompany', companyInfo);
		state.commit('setExperienceJob', jobInfo);
		state.commit('setJobIndustries', industries);
	},

	updateExperienceCompany(state: any, payload: any) {
		state.commit('setExperienceCompany', payload);
	},
	updateExperienceJob(state: any, payload: any) {
		state.commit('setExperienceJob', payload);
	},
	updateJobIndustries(state: any, payload: any) {
		state.commit('setJobIndustries', payload);
	},

	updateCurrentStep(state: any, payload: any) {
		state.commit('setCurrentStep', payload);
	},
};
